/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */

// Lib dependencies
import { makeVar, useReactiveVar } from '@apollo/client';

// Types
import { NavBarState } from '../NavBar/types';

/* -------------------------------------------------------------------------- */
/*                                Reactive var                                */
/* -------------------------------------------------------------------------- */

const navBarStateVars = makeVar<NavBarState>('expanded');

/* -------------------------------------------------------------------------- */
/*                                Custom hook                                 */
/* -------------------------------------------------------------------------- */
export const useNavBar = () => {
  const navBarState = useReactiveVar(navBarStateVars);
  return {
    state: navBarState,
    isExpanded: navBarState === 'expanded',
    isCollapsed: navBarState === 'collapsed',
    className: `navbar-${navBarState}` as const,
    toggleState: () => {
      navBarStateVars(navBarState === 'expanded' ? 'collapsed' : 'expanded');
    },
  };
};
